export default __webpack_public_path__ + "static/media/ArrowRight.9f67cd20.svg";